module.exports = __webpack_public_path__ + "images/assets/b16197b21cb141de99694b73e090ea9e.svg";